import { takeLatest } from 'redux-saga/effects';
import * as t from '../../../../actionTypes';
import searchUserForConsole from './searchUserForConsole';
import searchSingleUserForConsole from './searchSingleUserForConsole';
import forceResetPassword from './forceResetPassword';

// eslint-disable-next-line func-names
export default function*() {
  yield takeLatest(t.SEARCH_USER_FOR_CONSOLE, data => searchUserForConsole(data));
  yield takeLatest(t.SEARCH_SINGLE_USER_FOR_CONSOLE, data => searchSingleUserForConsole(data));
  yield takeLatest(t.REQUEST_PASSWORD_RESET, data => forceResetPassword(data));
}
